"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCompanySetingsCardsState = void 0;
const zustandStore_1 = require("../../../../../zustandStore");
const usePaymentState = () => {
    const { cardSourceTeams, cardSourceId, card: cardSource, cards: companyCardSources, } = (0, zustandStore_1.useZustand)((state) => state.payment);
    return { cardSourceTeams, cardSourceId, companyCardSources, cardSource };
};
const useAsideState = () => {
    const { cardSourceDetail, selectTeams: { options: cardOptions }, } = (0, zustandStore_1.useZustand)((state) => state.aside);
    return { cardSourceDetail, cardOptions };
};
const useTeamState = () => {
    const { teamId } = (0, zustandStore_1.useZustand)((state) => state.team);
    return { teamId };
};
const useCompanySetingsCardsState = () => {
    const { setUser, setCompanyName, setCompanyId, setHeaderName, setCardSourceId, setIsAddSourceCardOpen, setIsCardSourceDetailOpen, setIsSelectTeamsOpen, setOpenAsides, setNotification, cardSourceSetErrors, company, aside, } = (0, zustandStore_1.useZustand)();
    const { cardSourceTeams, cardSourceId, companyCardSources, cardSource } = usePaymentState();
    const { cardSourceDetail, cardOptions } = useAsideState();
    const { teamId } = useTeamState();
    return {
        setUser,
        setCompanyName,
        setCompanyId,
        setHeaderName,
        setCardSourceId,
        setIsAddSourceCardOpen,
        setIsCardSourceDetailOpen,
        setIsSelectTeamsOpen,
        setOpenAsides,
        setNotification,
        cardSourceSetErrors,
        company,
        cardSource,
        cardSourceTeams,
        cardSourceId,
        cardSourceDetail,
        cardOptions,
        companyCardSources,
        teamId,
        aside,
    };
};
exports.useCompanySetingsCardsState = useCompanySetingsCardsState;
